<script>


import Button from "../Button.vue";
export default {
  name: 'modalLang',
  props: ['translations', 'translateKey','scopeLang'],
  components: {Button},
  data: function () {
    return {
      selling_price: null,
      cost_price:null,
      config: null,
      currentLang: ''
    }
  },
  mounted: function(){

  },
  created: function() {

    this.languages = []

    this.$store.state.locales.forEach((el) => {
      this.languages[el.id] = el.name
    })

    //this.initialize();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    validate(){
      this.$emit('validate');
    },
    selectLang(lang) {
      this.currentLang = lang
      this.$emit('selectLang', lang)
    }
  },
};
</script>
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-overlay" @click="close()"></div>
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <h1>Select a language source</h1>
        <ul v-if="Object.keys(translations).length > 1" class="lang-list">
          <li  :class="[currentLang === lang ? 'active' : '', translations[lang][translateKey] === '' || translations[lang][translateKey] === null ? 'disabled' : '', scopeLang === lang ? 'hidden' : '' ]"  @click="selectLang(lang)" class="lang-flag" v-for="lang in Object.keys(translations)">
            <img class="lang-img" :src="'/src/assets/flags/'+lang+'.svg'">
            <div class="lang-content">
              <span>{{languages[lang]}}</span>
              <span v-if="translations[lang][translateKey] === '' || translations[lang][translateKey] === null">Aucune donnée disponible</span>
              <div  v-else v-html="translations[lang][translateKey]" class="translation-details"></div>
            </div>

          </li>
        </ul>
        <div style="flex: 1; display: flex; justify-content: center; align-items: center;" v-else>Multi language is not supported</div>
        <div class="lang-btns">
          <Button type="custom" label="Close" @callback="close"></Button>
          <Button v-if="Object.keys(translations).length > 1" type="custom" className="lang-button" label="Select" @callback="validate"></Button>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
h1 {
  font-size: 2em;
  margin-top: 1em;
  margin-bottom: .5em;
}
.modal {
  padding: 3em;
}
.lang-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding-top: 1em;
  padding-bottom: 1em;
}
.lang-flag {
  background: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 10px;
  cursor: pointer;
  padding: 1em;
  opacity: 0.8;
  transition:  180ms ease-in-out;
  border: 1px solid transparent;
  max-height: 200px;
  overflow: hidden;
}
/*.lang-content {*/
/*  !*display: flex;*!*/
/*  !*flex-direction: column;*!*/
/*  !*gap: 5px;*!*/
/*  !*height: 100%;*!*/
/*}*/

.lang-flag.active {
  border: 1px solid #cecece;
  opacity: 1;
}
.disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.2;
}
.lang-flag:hover {
  transform: scale(1.01);
  transition:  0.25s ease-in-out;
}

.lang-img {
  width: 60px;
}
.hidden {
  display: none !important;
}
.translation-details {
  max-height: 300px;
  overflow: hidden;
  font-weight: 400;
  font-size: 1.5em;
}
.lang-btns {
  display: flex;
  flex-direction: row;
  margin-left: 1em;
  margin-right: 1em;
  justify-content: flex-end;
  gap: 10px;
}
.lang-button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Gotham Rounded', sans-serif;
  background: var(--color-black);
  color: #FFF;
  border: 1px solid transparent;
  line-height: 30px;
  padding: 0 1em;
  font-weight: 400;
  letter-spacing: 0.01em;
  border-radius: 3px;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 11px;
}
.languages-switcher ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  position: relative;
  right: 0;
}
.languages-switcher li {
  display: flex;
  flex-direction: row;
}
.languages-switcher ul li.active:before {
  content: none;
  height: 0;
  width: 100%;
  bottom: 0;
  left: inherit;
  position: relative;
  transform: translateX(0%);
  background: transparent;
  margin-top: 0;
}
.languages-switcher ul li img {
  display: block;
  width: 60px;
  height: auto;
  position: relative;
  top: inherit;
  transform: none;
  left: inherit;
}
.languages-switcher span {
  display: block;
  line-height: inherit;
  padding: 0;
  width: auto;
  height: auto;
}

</style>


// WEBPACK FOOTER //
// src/components/form/ModalLang.vue